export default "__VITE_ASSET__2e697bea__"